import { GameLogic } from '../GameLogic';

export class BonusLogic {
    protected _config: any;
    protected _active: boolean;
    protected _gameLogic: GameLogic;

    public apply(gameLogic: GameLogic): void {
        this._active = true;
        this._gameLogic = gameLogic;
    }

    public cancel(): void {
        this._active = false;
    }

    public add(gameLogic: GameLogic): void {
        this._gameLogic = gameLogic;
    }

    public destroy(): void {
        this._active = false;
    }

    public update(frameTime: number): void {}

    public isActive(): boolean {
        return this._active;
    }

    public addTime(value): void {}

    public getTime(): number {
        return 0;
    }

    public getConfig(): any {
        return this._config;
    }
}
